export const statusTypes = [
  {
    text: 'Active',
    value: 'active',
  },
  {
    text: 'Close',
    value: 'close',
  },
  {
    text: 'Disqualified',
    value: 'disqualified',
  },
  {
    text: 'Auto-disqualified',
    value: 'auto-disqualified',
  },
]

export const withdrawalTypes = [
  {
    text: 'Not selected',
    value: 'not selected',
  },
  {
    text: 'Instant',
    value: 'instant',
  },
  {
    text: 'Trading',
    value: 'trading',
  },
]

export enum Statuses {
  ACTIVE = 'active',
  ENDING = 'ending',
  ENDED = 'ended',
  AUTO_BANNED = 'auto_banned',
  BANNED = 'banned',
  CLOSED = 'closed',
}
